module.exports = __webpack_public_path__ + "img/icon_sec2_03.a4e1d86c.png";